import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Table, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import { Authorization } from "../../Context/Authorization";
import Preloader from "../../shared/PreLoaders";
import * as XLSX from "xlsx";
import { Button } from "react-bootstrap";

const VFCRenwalPage = () => {
  const Api = process.env.REACT_APP_API;

  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);

  useEffect(() => {
    fetchReport();
  }, []);

  const fetchReport = async () => {
    try {
      setLoading(true);

      const config = Authorization();

      const res = await axios.get(
        `${Api}/api/check/service-charge-range-report`,
        config
      );

      setReport(res.data?.data || []);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load report");
    } finally {
      setLoading(false);
    }
  };
  const exportToExcel = () => {
    if (!report.length) return;

    const excelData = report.map((item, index) => ({
      "S.No": index + 1,
      Division: item.division,
      Range: item.range,
      "No Of VFC": item.noOfVfc,
      Amount: item.amount,
    }));

    excelData.push({
      "S.No": "",
      Division: "",
      Range: "TOTAL",
      "No Of VFC": totalVfc,
      Amount: totalAmount,
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 25 },
      { wch: 25 },
      { wch: 15 },
      { wch: 20 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "VFC Renewal Report"
    );

    XLSX.writeFile(
      workbook,
      `VFC_Renewal_Report_${new Date()
        .toISOString()
        .split("T")[0]}.xlsx`
    );
  };
  const totalVfc = report.reduce(
    (sum, item) => sum + Number(item.noOfVfc || 0),
    0
  );

  const totalAmount = report.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  );

  return (
    <div className="container-fluid">
      <Preloader loading={loading} />

      <Card className="mt-3">
        <Card.Body>
          <h4 className="mb-3">VFC Renewal Report</h4>
          <div className="d-flex justify-content-end mb-3">
            <Button variant="success" onClick={exportToExcel}>
              Export Excel
            </Button>
          </div>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Division</th>
                <th>Range</th>
                <th className="text-end">No Of VFC</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>

            <tbody>
              {report.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.division}</td>
                  <td>{item.range}</td>
                  <td className="text-end">
                    {item.noOfVfc?.toLocaleString("en-IN")}
                  </td>
                  <td className="text-end">
                    ₹{Number(item.amount || 0).toLocaleString("en-IN")}
                  </td>
                </tr>
              ))}
            </tbody>

            {report.length > 0 && (
              <tfoot>
                <tr>
                  <th colSpan={3} className="text-end">
                    Total
                  </th>
                  <th className="text-end">
                    {totalVfc.toLocaleString("en-IN")}
                  </th>
                  <th className="text-end">
                    ₹{totalAmount.toLocaleString("en-IN")}
                  </th>
                </tr>
              </tfoot>
            )}
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default VFCRenwalPage;